import React, { type ReactNode } from "react";
import {
  BusinessType,
  isBusinessTypeEnabled,
  isEducationIndustryEnabled,
  usePlatformConfig
} from "@kivunova/kivufrontendcommon";
import FeatureUnavailablePage from "./FeatureUnavailablePage";

interface IndustryRouteGuardProps {
  /** JWT business type required for this route prefix (e.g. portal/education/*). */
  requiredType: BusinessType;
  children: ReactNode;
}

const isIndustryModuleEnabled = (
  requiredType: BusinessType,
  featureFlags: Record<string, boolean>
): boolean => {
  if (requiredType === BusinessType.EDUCATION) {
    return isEducationIndustryEnabled(featureFlags);
  }
  return true;
};

/**
 * Blocks industry-specific routes when the tenant JWT businessType, stage flags,
 * or layer-2 industry module flag do not allow the industry.
 */
const IndustryRouteGuard: React.FC<IndustryRouteGuardProps> = ({
  requiredType,
  children
}) => {
  const { config, featureFlags } = usePlatformConfig();
  const tenantBusinessType = config?.businessType;

  const businessTypeEnabled = isBusinessTypeEnabled(requiredType, featureFlags);
  const industryModuleEnabled = isIndustryModuleEnabled(
    requiredType,
    featureFlags
  );
  const tenantMatches =
    tenantBusinessType != null && tenantBusinessType === requiredType;

  if (!businessTypeEnabled || !industryModuleEnabled || !tenantMatches) {
    return <FeatureUnavailablePage />;
  }

  return <>{children}</>;
};

export default IndustryRouteGuard;
